import React from "react"
import ViewTriageScreen from "../components/RPMCriticalInitialScreen/ViewTriage/ViewTriageScreen"

const RPMViewTriageInitialScreen = () => <ViewTriageScreen />

export default RPMViewTriageInitialScreen
